/** 销售项目版块API */
import type { Api } from '@/typings/api';
import { post } from '../../request';
const prefix = '/st/stCategorySection';
/**
 * 分页查询销售项目版块
 *
 * @param params 查询参数
 */
export const findPage: Api.CommonMethods.FindPage<Api.St.StCategorySection> = params => {
  return post(`${prefix}/findPage`, params);
};
/**
 * 查询销售项目版块列表
 *
 * @param params 查询参数
 */
export const findAll: Api.CommonMethods.FindAll<Api.St.StCategorySection> = params => {
  return post(`${prefix}/findAll`, params);
};
/**
 * 查询销售项目版块列表
 *
 * @param params 查询参数
 */
export const getAllSection: Api.CommonMethods.FindAll<Api.St.StCategorySection> = params => {
  return post(`${prefix}/getAllSection`, params);
};
/**
 * 查询单个销售项目版块
 *
 * @param id 销售项目版块ID
 * @param column 查询字段
 */
export const findOne: Api.CommonMethods.FindOne<Api.St.StCategorySection> = (id: string, column?: string[]) => {
  return post(`${prefix}/findOne`, { id, column });
};
/**
 * 保存销售项目版块
 *
 * @param params 销售项目版块信息
 */
export const doSave: Api.CommonMethods.Save = params => {
  return post(`${prefix}/save`, params);
};
/**
 * 更新销售项目版块信息
 *
 * @param params 销售项目版块信息
 */
export const doUpdate: Api.CommonMethods.Update = params => {
  return post(`${prefix}/update`, params);
};
/**
 * 删除销售项目版块
 *
 * @param id 销售项目版块ID
 */
export const doDelete: Api.CommonMethods.Delete = id => {
  return post(`${prefix}/delete?id=${id}`);
};
/**
 * 批量删除销售项目版块
 *
 * @param ids 销售项目版块ID数组
 */
export const doBatchDelete: Api.CommonMethods.BatchDelete = ids => {
  return post(`${prefix}/deleteList`, { ids });
};
export const getNotSharedSection: Api.CommonMethods.Save = params => {
  return post(`${prefix}/getNotSharedSection`, params);
};
export default {
  findPage,
  findOne,
  doSave,
  doUpdate,
  doDelete,
  doBatchDelete,
  getNotSharedSection,
  getAllSection
};
